(function () {
  var VISIBLE_CLASS = 'c_mwam_reveal--visible';
  var GROUPS = [
    { selector: '.c_mwam_reveal:not(.c_mwam_reveal--late)', margin: '-5%' },
    { selector: '.c_mwam_reveal--late', margin: '-10%' }
  ];

  if (window.c_mwam_reveal_ready) {
    return;
  }
  window.c_mwam_reveal_ready = true;

  function show(element) {
    element.classList.add(VISIBLE_CLASS);
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.c_mwam_reveal').forEach(show);
    return;
  }

  function onIntersect(entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) {
        return;
      }
      show(entry.target);
      observer.unobserve(entry.target);
    });
  }

  var groups = GROUPS.map(function (group) {
    return {
      selector: group.selector,
      observer: new IntersectionObserver(onIntersect, {
        rootMargin: '0px 0px ' + group.margin + ' 0px'
      })
    };
  });

  function observe(root) {
    groups.forEach(function (group) {
      root.querySelectorAll(group.selector).forEach(function (element) {
        if (element.classList.contains(VISIBLE_CLASS)) {
          return;
        }
        group.observer.observe(element);
      });
    });
  }

  observe(document);

  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
